import { LocalizationService } from '@abp/ng.core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { SelectorComponent } from 'src/ca-shared/selector/selector.module';
import { Operators } from 'src/core/models/request/operator.enum';
import { LanguageSelectionConfigurationModel } from '../models/language-selection-configuration.model';
import { FilterItemDto } from 'src/core/models/request/filter-item.dto';
import { LanguageDto } from '@volo/abp.ng.language-management/proxy';

@Component({
  selector: 'ca-language-selection-panel',
  templateUrl: './language-selection-panel.component.html',
  styleUrls: ['./language-selection-panel.component.scss'],
  standalone: false,
})
export class LanguageSelectionPanelComponent extends FilterPanelEditorComponent implements OnInit {
  actualConfig: LanguageSelectionConfigurationModel;

  _value: LanguageDto[];
  languageSelectorOptions: any;

  @ViewChild(SelectorComponent, { read: SelectorComponent })
  languageSelector: SelectorComponent;
  languageFilters: FilterItemDto[];

  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as LanguageSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  set value(value: any) {
    this.editorForm.patchValue({
      editor: value,
    });
  }

  get value(): any {
    return this._value;
  }

  constructor(
    private localizationService: LocalizationService,
    private operators: Operators,
    protected fb: FormBuilder
  ) {
    super(fb);
    this.languageFilters = [
      {
        field: 'isVisible',
        operator: this.operators.Contains,
        value: true,
      },
      {
        field: 'onlyConfiguredLanguages',
        operator: this.operators.Contains,
        value: true,
      },
    ];

    this.languageSelectorOptions = {
      pageSize: 5,
      queryOperator: this.operators.Contains,
      queryField: 'quickSearchTerm',
      emptyText: this.localizationService.instant('::SelectLanguage'),
      multiple: true,
      url: 'api/app/configuration-settings/language-code',
      currentPage: 1,
      showSelections: false,
      showClearSelections: false,
      showClearSelectionLink: true,
      selectorPosition: 'Top',
      filters: this.languageFilters,
    };

    this.editorForm.valueChanges.subscribe(val => {
      this._value = val.editor;
      this.onChange();
    });
  }

  ngOnInit(): void {}

  reload(): void {}

  reset(): void {
    this.languageSelector.currentPage = 1;
  }
  autoSelectFirstItem(): void {}

  init() {
    super.init();
    if (this.actualConfig.autoLoad) {
      this.languageSelector.refresh();
    }
  }
}
